import { currentGameConfig } from 'utils/handleCurrentContentConfig';

export function getBanner({ event, data }) {
  const { fileHost } = currentGameConfig;
  const { iZMp } = data[event];
  const banner = Object.values(iZMp).find(({ mTe, lon }) => mTe === 'B' && lon === 'S10');
  return banner && fileHost + banner.src;
}

const getOffers = ({ event, data }) => {
  if (!data || !data[event]) return { offers: [], dailyBonus: null, vipGift: null };

  const { iZMp, des } = data[event];
  const actionIds = [2];
  const decisionIds = [1, 2];
  const templateIds = ['B', 'P', 'EDB', 'EVIP'];

  let dailyBonus;
  let vipGift;
  const izObj = {};

  const offers = {
    1: { data: [], title: 'Deal of the day' },
    2: { data: [], title: 'Special Daily Offers' },
    3: { data: [], title: 'Best Daily Offers' },
    rest: { data: [], title: 'Deals' },
  };

  const createPackageFromIz = izid => {
    if (izObj[izid]) return;

    izObj[izid] = izid;
    const { chn, acs, tId, vLt, src } = iZMp[izid];

    if (chn) {
      chn.forEach(childrenIzid => createPackageFromIz(childrenIzid));
    } else if (templateIds.includes(tId) || templateIds.includes(tId?.[0])) {
      acs.forEach(({ aId, vae, dCt }, index, { length }) => {
        if (aId === 18 && tId === 'EDB') {
          dailyBonus = { izid, vae, ...dCt };
        } else if (tId === 'EVIP') {
          const now = Date.now() / 1000;
          const expiration = vLt?.exs;

          if (!expiration || now <= expiration) {
            vipGift = { izid, vae, src, vLt, ...dCt };
          }
        } else if (actionIds.includes(aId)) {
          const isAscending = acs.at(0).dCt.cot < acs.at(-1).dCt.cot;
          (offers[length]?.data || offers.rest.data).push({
            izid,
            vae,
            vLt,
            ...dCt,
            gLt: dCt.gLt.slice(0, 5),
            assetKey: `order${length}_${isAscending ? index + 1 : length - index}`,
          });
        }
      });
    }
  };

  des.forEach(({ id, iZs }) => decisionIds.includes(id) && iZs.forEach(izid => createPackageFromIz(izid)));
  const filterdOffers = Object.values(offers).filter(({ data }) => data.length);
  return { offers: filterdOffers, dailyBonus, vipGift };
};

const storeService = {
  getBanner,
  getOffers,
};

export default storeService;
